<template>
<div class="wrapper">
  <div v-if="!loading">
      <div>
        <CButton class="col-1 mt-3 " variant="outline" color="info" @click="print()">Print</CButton>
        <CButton class="col-3 mt-3 " variant="outline" color="info">
          <download-excel
            :data="json_data"
            :fields="json_fields"
            :name= "filename"
          >
            Download Excel
          </download-excel>
        </CButton>
      </div>
      <br>
      <div class="panel-body" id="print">
        <h3>Report Attendance</h3>
        <h6>Event Name: {{ event_name }}</h6>
        <h6>Event Date: {{ event_date }}</h6>
        <br>
        <table class="table" style="width:1000px">
          <thead>
            <tr>
              <th style="width: 10px;">#</th>
              <th style="width: 400px;">Name</th>
              <th style="width: 400px;">DOB</th>
              <th style="width: 400px;">Gender</th>
              <th style="width: 400px;">Age Group</th>
              <!-- <th style="width: 200px;">Email</th> -->
              <!-- <th style="width: 200px;">Visitor Attendance</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dt, index) in rpt" :key="index">
              <td>{{ index+1 }}</td>
              <td>{{ dt.name }}</td>
              <td>{{ dt.dob }}</td>
              <td>{{ dt.sex }}</td>
              <td>{{ dt.age_group }}</td>
              <!-- <td>{{ dt.email }}</td> -->
              <!-- <td>{{ dt.count_visitor }}</td> -->
            </tr>
          </tbody>
        </table>
      </div>    
  </div>
  <div v-else class="d-flex content-center min-vh-100">
      <b-spinner variant="primary" label="Spinning"><br></b-spinner>
  </div>


</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import axios from 'axios';

import report from '@/services/report';

import Vue from "vue";
import JsonExcel from "vue-json-excel";

import moment from 'moment'
 
Vue.component("downloadExcel", JsonExcel);

export default {
  
    data(){
        return{
          rpt:'',
          period:'',
          loading: false,
          filename: "a.xls",
          event_name:'',
          event_date:'',
          json_fields: {
              "Name": "name",
              // "Email": "email",
              "DOB": "dob",
              "Gender": "sex",
              "Age Group": "age_group",
              //"Visitor Attendance": "count_visitor"

          },
          json_data: [],
          json_meta: [
            [
              {
                key: "charset",
                value: "utf-8",
              },
            ],
          ],
        }
    },
    created(){
      this.loadData()
    },
    mounted() {
      
    },
   
    methods: {
      loadData(){
        var params = {
          event_id: this.$route.query.id
        }
        this.loading = true
        report.getEventReportAttendance(params)
        .then(res => {
            let getData = res.data
            // this.period = res.periodMonth + ' ' + res.periodYear
            // this.filename = "Icare Report " + this.period
            this.rpt = getData
            this.json_data = getData
            this.event_name = res.event.name
            this.event_date = moment(res.event.datetime_event, 'YYYY-MM-DD').format('DD MMMM YYYY');
            this.filename = "Event Attendance " + this.event_name.replace('.','') + " - " + this.event_date
            this.loading = false
        }).catch ((err) => { 
          alert(err.response.data.message)
        })
      },
      print () {
        // Pass the element id here
        this.$htmlToPaper('print', null, () => {
          console.log('Printing completed or was cancelled!');
        });
      },
    }
}
</script>
